import {useTranslation} from "react-i18next";

export const GetShippingMethods = async () => {
    try {
        return [
            {
                value: '1',
                label: 'Shipping Method 1'
            },
            {
                value: '2',
                label: 'Shipping Method 2'
            },
            {
                value: '3',
                label: 'Shipping Method 3'
            },
            {
                value: '4',
                label: 'Shipping Method 4'
            },
        ];

    } catch (error) {
        console.error('Error fetching shipping methods:', error);
        throw error;
    }
};